const $ = require('jquery');
const bootbox = require('bootbox');

window.addEventListener('load', function() {
  $('body').on('submit', 'form.confirm', (event) => {
    const $form = $(event.currentTarget);
    if ($form.data('force-submit') !== true) {
      event.preventDefault();
      bootbox.confirm({
        backdrop: true,
        message:
          'Sind Sie sicher, dass Sie dieses Formular so abschicken möchten?<br><small><kbd>Enter</kbd> = Ja, <kbd>Esc</kbd> = Nein</small>',
        buttons: {
          confirm: {
            label: 'Ja',
          },
          cancel: {
            label: 'Nein',
          },
        },
        callback(result) {
          if (result) {
            $form.data('force-submit', true);
            $form.trigger('submit');
          }
        },
      });
    }
  });
});
